"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQueryString = void 0;
const getQueryString = (data) => {
    const params = new URLSearchParams();
    Object.keys(data).forEach((key) => {
        const value = data[key];
        if (Array.isArray(value)) {
            value.forEach((element) => {
                if (element) {
                    params.append(`${key}[]`, element);
                }
            });
        }
        else {
            params.append(key, value);
        }
    });
    return decodeURIComponent(params.toString());
};
exports.getQueryString = getQueryString;
//# sourceMappingURL=utils.js.map